import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Component({
    selector: 'app-github',
    templateUrl: './github.component.html',
    styleUrls: ['./github.component.scss'],
})
export class GithubComponent implements OnInit {
    destroy$ = new Subject();

    public githubForm: FormGroup;
    repositories: any[];
    loadingLoad: boolean = false;
    isShownLoad: boolean = false;
    deploymentsInfos = [];
    loadingDeploymentInfosLoad = false;
    isDeploymentInfosShownLoad = false;
    baseBranchName: string;
    headBranchName: string;

    constructor(private configService: ConfigurationService, private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.githubForm = this.formBuilder.group({
            baseBranchName: new FormControl(null, [Validators.required]),
            headBranchName: new FormControl(null, [Validators.required]),
        });
    }

    compareBranches() {
        this.loadingLoad = true;
        this.githubForm.markAllAsTouched();
        if (this.githubForm.invalid) {
            return;
        }
        const filters: any = {
            baseBranchName: this.baseBranch.value,
            headBranchName: this.headBranch.value,
        };
        const queryString = Object.keys(filters)
            .map((key) => key + '=' + filters[key])
            .join('&');
        this.configService.compareBranches(queryString).subscribe((repositories) => {
            this.loadingLoad = false;
            this.isShownLoad = true;
            this.repositories = repositories;
        });
    }

    getDeploymentsInfos() {
        this.loadingDeploymentInfosLoad = true;
        this.configService.getDeploymentsInfos().subscribe((deploymentsInfos) => {
            this.loadingDeploymentInfosLoad = false;
            this.isDeploymentInfosShownLoad = true;
            this.deploymentsInfos = deploymentsInfos;
        });
    }

    get baseBranch() {
        return this.githubForm.get('baseBranchName');
    }
    get headBranch() {
        return this.githubForm.get('headBranchName');
    }
}
